import { useQuery } from "@tanstack/react-query";
import { PinovaStation } from "services/iot/models";
import { createAuthService } from "services/serviceFactory";

const iotAuthService = createAuthService("iot");
const iotBase = "/iot/";

export const usePinovaStationsQueries = (enabled: boolean = true) => {
    const results = useQuery({
        queryKey: ["iot", "pinovaStations"],
        queryFn: async () => {
            const response = await iotAuthService.post<PinovaStation[]>(
                `${iotBase}Pinova/GetPinovaStationsAsync`
            );
            return response.data;
        },
        enabled,
        
    });

    return {
        pinovaQuery: results,
        isLoading: results.isLoading,
        isError: results.isError,
        pinovaStations: results.data ?? [],
    };
};
